import React from 'react';
const DocumentItem = ({ requirement }) => {
    return (
        <div className='my-1'>
            <div className='flex items-center'>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="gray" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>

                <span className='ml-2 '>
                    {requirement.requirementTitle}
                </span>

            </div>
            <div className='ml-[5%] break-words font-extralight'>
                {requirement.requirementDescription}
            </div>
        </div>
    );
}

export default DocumentItem;